export default __webpack_public_path__ + "static/media/icon-task.349321c3.svg";